module.exports = __webpack_public_path__ + "img/Picnic.4287ce0d.svg";